import { useIsFocused } from "@react-navigation/native";
import { useContext, useEffect, useState } from "react";
import { ScrollView, StyleSheet, Text, View } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import PageTitle from "../../components/PageTitle";
import { GlobalContext } from "../../contexts/global";
import { PaymentHistoricByUser } from "../../services/Api/historic";
import * as Colors from "../../styles/colors";
import * as Fonts from "../../styles/typography";
import Item from "./components/Item";

export default function PaymentHistoric({ navigation }) {
  const { setLoading, setShowAlert, showAlert } = useContext(GlobalContext);
  const [historic, setHistoric] = useState([]);
  
  useEffect(() =>  setLoading({
    show: true,
    message: "Carregando histórico",
  }), [])

  const updateList = () => {
    PaymentHistoricByUser()
      .then((value) => {
        setHistoric(value.data);
      })
      .catch((error) => {
        setShowAlert({
          type: "alert",
          title: "Oops",
          message: "Erro ao tentar carregar o histórico",
          show: true,
          confirmText: "OK",
          pressCancel: () => {
            navigation.goBack();
          },
          pressConfirm: () => {
            navigation.goBack();
            setShowAlert({ ...showAlert, show: false });
          },
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setLoading({ show: false, message: "" });
      });
  };

  const isFocused = useIsFocused();

  useEffect(() => {
    if (isFocused) {
      updateList();
    }
  }, [isFocused]);

  return (
    <PageTitle title={"HISTÓRICO"} navigation={navigation}>
      <ScrollView
        style={styles.viewSecundaria}
        contentContainerStyle={{
          alignItems: "center",
          paddingBottom: 8,
          // flex: 1,
          flexGrow: 1,
        }}
      >
        {historic.length > 0 ? (
          historic.map((hist, index) => {
            if (!!hist.paymentHistoric) {
              return (
                <Item
                  item={hist}
                  key={hist.paY_CD_ORDER}
                  setLoading={setLoading}
                  setShowAlert={setShowAlert}
                />
              );
            }
          })
        ) : (
          <View
            style={{
              alignItems: "center",
              justifyContent: "center",
              flex: 1,
              flexGrow: 1,
            }}
          >
            <Icon name="history" size={128} color={Colors.BLACK} />
            <Text style={{ marginTop: 24, fontSize: Fonts.FONT_SIZE_16 }}>
              {"Nenhum pagamento encontrado."}
            </Text>
          </View>
        )}
      </ScrollView>
    </PageTitle>
  );
}

const styles = StyleSheet.create({
  viewSecundaria: {
    backgroundColor: Colors.WHITE,
    width: "100%",
    flex: 1,
    flexGrow: 1,
  },
});
